import React from 'react';
import { dollarsWithCentsWithSymbol } from 'helpers/currency';
import styled from 'styled-components';
import { useTripCalculator } from 'hooks/queries';
import { PricingSection, Fees } from './shared';

export default () => {
  const { tripCalculation } = useTripCalculator();

  return (
    <LongPriceSection gap="5px">
      <PriceList>
        <dt>Boat price</dt>
        <dd data-testid="pdp-booking-widget-boat-price-value">
          {dollarsWithCentsWithSymbol(tripCalculation?.boat_price)}
        </dd>
        {!!tripCalculation?.captain_fee && (
          <>
            <dt>Captain price</dt>
            <dd data-testid="pdp-booking-widget-captain-price-value">
              {dollarsWithCentsWithSymbol(tripCalculation?.captain_fee)}
            </dd>
          </>
        )}
        <hr />
        <dt className="total">Booking total</dt>
        <dd className="total" data-testid="pdp-booking-widget-booking-total-value">
          {dollarsWithCentsWithSymbol(tripCalculation?.pre_tax_and_fees_booking_total || 0)}
        </dd>
      </PriceList>
      <FeeNote>Additional fees will show at checkout</FeeNote>
    </LongPriceSection>
  );
};

const LongPriceSection = styled(PricingSection)`
  padding-top: 20px;
`;

const PriceList = styled.dl`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 5px;

  & dd {
    text-align: end;
  }

  & hr {
    grid-column: 1 / -1;
    width: 100%;
    height: 1px;
    color: rgba(219, 223, 229, 0.5);
    background-color: rgba(219, 223, 229, 0.5);
    margin-top: 15px;
    margin-bottom: 10px;
    border: none;
  }

  & .total {
    font-weight: 600;
  }
`;

const FeeNote = styled(Fees)`
  margin-bottom: 25px;
  padding-top: 0;
`;
